var map = {
	"./ar/translation.json": 2792,
	"./de/translation.json": 2793,
	"./el/translation.json": 2794,
	"./en/translation.json": 2795,
	"./es/translation.json": 2796,
	"./fil/translation.json": 2797,
	"./fr/translation.json": 2798,
	"./hi/translation.json": 2799,
	"./id/translation.json": 2800,
	"./it/translation.json": 2801,
	"./ko/translation.json": 2802,
	"./ms/translation.json": 2803,
	"./nl/translation.json": 2804,
	"./pl/translation.json": 2805,
	"./pt-BR/translation.json": 2806,
	"./pt-PT/translation.json": 2807,
	"./ru/translation.json": 2808,
	"./se/translation.json": 2809,
	"./tr/translation.json": 2810,
	"./uk/translation.json": 2811,
	"./zh/translation.json": 2812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2791;